import { leagues } from '@/mocks/leagues';
import { teams } from '@/mocks/teams';
import { matches } from '@/mocks/matches';
import { players } from '@/mocks/players';
import { newsList } from '@/mocks/news';
import { standings } from '@/mocks/standings';
import type { League, Team, Match, Player, News, Standing } from '@/types';

export const allLeagues = leagues as League[];
export const allTeams = teams as Team[];
export const allMatches = matches as Match[];
export const allPlayers = players as Player[];
export const allNews = newsList as News[];
export const allStandings = standings as Standing[];

export function getLeague(id?: string): League | undefined {
  return allLeagues.find((l) => l.id === id);
}

export function getTeam(id?: string): Team | undefined {
  return allTeams.find((t) => t.id === id);
}

export function getMatch(id?: string): Match | undefined {
  return allMatches.find((m) => m.id === id);
}

export function getPlayer(id?: string): Player | undefined {
  return allPlayers.find((p) => p.id === id);
}

export function getNews(id?: string): News | undefined {
  return allNews.find((n) => n.id === id);
}

export function getStanding(leagueId?: string): Standing | undefined {
  return allStandings.find((s) => s.leagueId === leagueId);
}

export function getTeamsByLeague(leagueId: string): Team[] {
  return allTeams.filter((t) => t.leagueId === leagueId);
}

export function getPlayersByTeam(teamId: string): Player[] {
  return allPlayers.filter((p) => p.teamId === teamId);
}

export function getMatchesByTeam(teamId: string): Match[] {
  return allMatches.filter((m) => m.homeTeamId === teamId || m.awayTeamId === teamId);
}

export function getMatchesByLeague(leagueId: string): Match[] {
  if (!leagueId || leagueId === 'all') return allMatches;
  return allMatches.filter((m) => m.leagueId === leagueId);
}

export function getNewsByTeam(teamId: string): News[] {
  return allNews.filter((n) => n.relatedTeamIds.includes(teamId));
}

export function getNewsByMatch(matchId: string): News[] {
  return allNews.filter((n) => n.relatedMatchId === matchId);
}

export const newsCategories = ['全部', '赛事新闻', '赛后分析', '转会消息'];

export function searchAll(query: string) {
  const q = query.trim().toLowerCase();
  if (!q) {
    return { leagues: [], teams: [], players: [], matches: [], news: [] };
  }
  const hit = (text: string) => text.toLowerCase().includes(q);
  return {
    leagues: allLeagues.filter((l) => hit(l.name) || hit(l.shortName)),
    teams: allTeams.filter((t) => hit(t.name) || hit(t.short) || hit(t.city) || hit(t.leagueName)),
    players: allPlayers.filter((p) => hit(p.name) || hit(p.enName) || hit(p.position)),
    matches: allMatches.filter((m) => {
      const home = getTeam(m.homeTeamId);
      const away = getTeam(m.awayTeamId);
      return hit(m.leagueName) || hit(home?.name || '') || hit(away?.name || '');
    }),
    news: allNews.filter((n) => hit(n.title) || hit(n.summary) || hit(n.category)),
  };
}